import "./tours.scss";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import React, { useEffect, useState } from "react";
import axios from "axios";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { NavLink, Link } from "react-router-dom";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import { showSwalError } from "../utilities/swal";
import { sendRequest } from "../utilities/useAxios";
import logo from "../assets/image/20211007_120244.jpg";
import ReactPaginate from "react-paginate";

function GalleryItem({ info, date }) {
  return (
    <>
      <div className="col-lg-4 col-md-6 col-12">
        <div
          className="card round border-success m-1   "
          style={{ direction: "rtl", overflow: "hidden", borderRadius: "25px" }}
        >
          <NavLink to={`/single-tour/${info.id}`} style={{ height: "380px" }}>
            <div className="position-relative" style={{ height: "48%" }}>
              <img
                alt="not found"
                src={
                  info.cover_pic == "" || info.cover_pic == undefined
                    ? logo
                    : "http://mvc.dade24.ir/" + info.cover_pic
                }
                className="card-img-top  border tour-border-color h-100 my-auto"
                style={{
                  objectFit: "fill",
                  borderTopLeftRadius: "25px",
                  borderTopRightRadius: "25px",
                }}
                width={30}
              />
              {/* <div className="position-absolute rounded tourLabel1 size3">
                {info.title}
              </div> */}
              {/* <div className="position-absolute rounded tourLabel2 size2  digits fw-bold">
                زمان: {date(info.stm)}
              </div> */}
            </div>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                width: "100%",
                height: "40px",
                backgroundColor: "tomato",
                color: "white",
                backgroundImage:
                  "linear-gradient(to right, #b21729, #d8162e, #b21729)",
              }}
            >
              <div style={{ fontWeight: "bolds" }}>{info.title}</div>
            </div>
            <div className="card-body size5 d-flex flex-column justify-content-around">
              <div className="row  text-dark">
                <div
                  className="way-color col-6 font-regular fw-bold"
                  style={{ color: "#838282" }}
                >
                  مدت :
                </div>
                <div className="col-6  fw-bold digits">
                  {Math.ceil((parseInt(info.ftm) - parseInt(info.stm)) / 86400)}{" "}
                  روزه
                </div>
              </div>
              <div className="row  text-dark">
                <div
                  className="way-color col-6 font-regular fw-bold"
                  style={{ color: "#838282" }}
                >
                  تاریخ رفت:
                </div>
                <div className="col-6  fw-bold digits">{date(info.stm)}</div>
              </div>
              <div className="row  text-dark">
                <div
                  className="way-color col-6 font-regular fw-bold"
                  style={{ color: "#838282" }}
                >
                  تاریخ برگشت:
                </div>
                <div className="col-6  fw-bold digits">{date(info.ftm)}</div>
              </div>
              <div className="row ">
                <div
                  className="way-color col-6 font-regular fw-bold"
                  style={{ color: "#838282" }}
                >
                  قیمت:
                </div>
                <div className="col-6 digits fw-bold  price">
                  {parseInt(info.mainprice).toLocaleString()} تومان
                </div>
              </div>
              <div className="row  text-dark">
                <div
                  className="way-color col-6 font-regular fw-bold"
                  style={{ color: "#838282" }}
                >
                  ظرفیت:
                </div>
                <div className="col-6 digits fw-bold ">
                  {parseInt(info.public_capacity) -
                    (parseInt(info.frozen_reserved) +
                      parseInt(info.complate_reserved)) <=
                  0
                    ? " تکمیل شده"
                    : `${
                        parseInt(info.public_capacity) -
                        (parseInt(info.frozen_reserved) +
                          parseInt(info.complate_reserved))
                      }نفر `}
                </div>
              </div>

              {/* {info.essentials_accessories == 0 ? null : (
                <div className="row my-1">
                  <div className="way-color col-6 font-regular">اقلام مورد نیاز:</div>
                  <div className="col-6 digits d-flex">
                    <div className="d-flex flex-column mt-2 text-dark">
                      <div
                        style={{
                          width: "100%",
                          height: "24px",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: "1",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        <p>{info.essentials_accessories}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
            </div>
          </NavLink>
        </div>
      </div>
    </>
  );
}

function Card({ info }) {
  const date = (TimeStamp) => {
    let options = { month: "long", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
      "fa-IR",
      options
    );
    date.replace(/([۰-۹])/g, (token) =>
      String.fromCharCode(token.charCodeAt(0) - 1728)
    );
    return date;
  };

  return (
    <>
      <NavLink to={`/tak-tour/${info.id}`}>
        <div
          className="card col-sm-12 mt-2"
          style={{ width: "18rem", borderRadius: 12 }}
        >
          <div className="card-body"></div>
          <div className="row card-title ms-2 mb-2">
            <div className="way-color col-6 ">عنوان:</div>
            <div className="col-6  fw-bold digits">{info.title}</div>
          </div>
          <div className="row card-text ms-2 mb-2">
            <div className="way-color col-6 ">تاریخ رفت : </div>
            <div className="col-6  fw-bold digits">{date(info.stm)}</div>
          </div>
          <div className="row card-text ms-2 mb-2">
            <div className="way-color col-6">تاریخ برگشت :</div>
            <div className="col-6  fw-bold digits">{date(info.ftm)}</div>
          </div>
          <div className="row card-text ms-2 mb-3">
            <div className="way-color col-6 ">ظرفیت :</div>
            <div className="col-6  fw-bold digits">
              {parseInt(info.public_capacity) -
                (parseInt(info.frozen_reserved) +
                  parseInt(info.complate_reserved)) <=
              0
                ? " تکمیل"
                : `${
                    parseInt(info.public_capacity) -
                    (parseInt(info.frozen_reserved) +
                      parseInt(info.complate_reserved))
                  }نفر `}
            </div>
          </div>
        </div>
      </NavLink>
    </>
  );
}

export default function Tours() {
  const [Info, setInfo] = useState([]);
  const [InfoCopy, setInfoCopy] = useState([]);
  const [Tags, setTags] = useState([]);
  const [dates, setDates] = useState([]);
  const [public_capacity, setpublic_capacity] = useState("");
  const [filter, setFilter] = useState({
    public_capacity: "",
    stm: "",
    ftm: "",
    tour_title: "",
    main_tag_id: "",
  });
  const [pageNum, setPageNum] = useState(1);
  const [filterKey, setFilterKey] = useState(false);
  const [total_count, setTotal_count] = useState("");
  const [key, setKey] = useState(true);
  const [pagination, setpagination] = useState(0);

  const DeleteFilter = () => {
    setPageNum(1);
    setKey(!key);
    setpublic_capacity("");
    setDates([]);
    setFilter({
      ...filter,
      ["tour_title"]: "",
      ["public_capacity"]: "",
      ["main_tag_id"]: "",
      ["ftm"]: "",
      ["stm"]: "",
    });
    setFilterKey(false);
    setpagination(0);
  };

  const date = (TimeStamp) => {
    let options = { month: "long", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
      "fa-IR",
      options
    );
    date.replace(/([۰-۹])/g, (token) =>
      String.fromCharCode(token.charCodeAt(0) - 1728)
    );
    return date;
  };

  const Filter = (filter) => {
    setFilterKey(true);
    setPageNum(1);
    if (dates.length == 1) {
      showSwalError("\nلطفا دو روز را انتخاب کنید");
    } else {
      let filters = new FormData();
      Object.keys(filter).map((item) => {
        if (filter[item] != "") {
          filters.append(`${item}`, filter[item]);
        }
      });
      filters.append("page", `${pageNum}`);
      filters.append("count", "12");
      filters.append("status", "4");

      sendRequest("fulltour", filters)
        .then(({ data }) => {
          setpublic_capacity(filter.public_capacity);
          setInfo(data.data);
          setTotal_count(data.total_count);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const DeleteFilterInHead = () => {
    setInfo(InfoCopy);
    setKey(!key);
  };

  const FilterInHead = (item, Negative = 1) => {
    const currentDate = new Date().getTime();
    let info = [...Info];
    if (item == "stm") {
      info.sort(
        (a, b) =>
          Math.abs(a[item] - currentDate / 1000) -
          Math.abs(b[item] - currentDate / 1000)
      );
    } else {
      info.sort((a, b) => Negative * a[item] - Negative * b[item]);
    }
    setInfo(info);
  };

  // ظرفیت نمایشی - مجموع رزورو های فریز شده و کامل شده
  useEffect(() => {
    let tags = new FormData();
    tags.append("fields", "id,title");

    let tures = new FormData();
    tures.append("page", `${pageNum}`);
    tures.append("count", "12");
    tures.append("status", "4");

    sendRequest("fulltour", tures)
      .then(({ data }) => {
        setInfo(data.data);
        setTotal_count(data.total_count);
        setInfoCopy(data.data);
      })
      .catch((error) => {
        console.log(error);
      });

    sendRequest("Find_tour_tags", tags)
      .then(({ data }) => {
        setTags(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (filterKey) {
      Filter(filter);
    } else {
      let tures = new FormData();
      tures.append("page", `${pageNum}`);
      tures.append("count", "12");
      tures.append("status", "4");

      sendRequest("fulltour", tures)
        .then(({ data }) => {
          setInfo(data.data);
          setTotal_count(data.total_count);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNum, key]);

  return (
    <div className="Tours">
      <div className="mt-4">
        <nav className="navbar navbar-expand-lg navbar-expand-sm navbar-light  tours container d-flex">
          <div className="container col-lg-12 d-flex flex-wrap">
            <div className="col-lg-2 col-sm-1">
              <span
                className="navbar-brand ms-1"
                href="#"
                style={{ color: "#004d17", fontWeight: "bolder", fontSize: 25 }}
              >
                تورها
              </span>
            </div>

            <div
              class="btn-group w-75 sort-display"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <div
                className="justify-content-center col-lg-8 col-sm-12 "
                id="navbarText"
              >
                <div
                  className="mx-auto"
                  style={{ width: "fit-content" }}
                  href="#"
                >
                  <b>مرتب سازی بر اساس</b>
                </div>
                <ul
                  className="navbar-nav  mx-auto sort"
                  style={{ width: "fit-content" }}
                >
                  <li className="nav-item ">
                    <span
                      className="nav-link"
                      href="#"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check "
                        onClick={() => FilterInHead("stm", 1)}
                        name="btnradio"
                        id="btnradio1"
                        autocomplete="off"
                      />
                      <label
                        class="btn btn-outline-primary w-100"
                        for="btnradio1"
                      >
                        نزدیک ترین زمان
                      </label>
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className="nav-link "
                      href="#"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio2"
                        autocomplete="off"
                        onClick={() => FilterInHead("mainprice", -1)}
                      />
                      <label
                        class="btn btn-outline-primary w-100"
                        for="btnradio2"
                      >
                        گرانترین
                      </label>
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      href="#"
                      className="nav-link"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio3"
                        autocomplete="off"
                        onClick={() => FilterInHead("mainprice")}
                      />
                      <label
                        class="btn btn-outline-primary w-100"
                        for="btnradio3"
                      >
                        ارزانترین
                      </label>
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      href="#"
                      className="nav-link"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio4"
                        autocomplete="off"
                        onClick={DeleteFilterInHead}
                      />
                      <label class="btn btn-outline-danger" for="btnradio4">
                        <FaTrashAlt />
                      </label>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <div className="filter-tours-container container d-flex flex-wrap pt-5 ">
          <div
            className="col-lg-3 col-md-12 col-12  filter d-flex flex-wrap mb-5 sort-display"
            style={{ height: 400 }}
          >
            <div className="p-3 d-flex align-items-center col-12 ">
              <FaFilter className="fs-4" />
              <h6 className="ps-2">فیلتر تورها</h6>
            </div>
            <div className="col-lg-12 col-md-6 col-12">
              <div className="position-relative m-2">
                <input
                  type="text"
                  value={filter.tour_title}
                  onChange={(e) =>
                    setFilter({ ...filter, ["tour_title"]: e.target.value })
                  }
                  placeholder="نام تور"
                  className="font-regular search w-100"
                />

                <div className=" position-absolute p-2 icon">
                  <svg
                    fill="#000000"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="30px"
                    height="30px"
                  >
                    <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-6 col-12 ">
              <div className="position-relative m-2 date-picker">
                <DatePicker
                  calendar={persian}
                  range
                  id=""
                  mainPosition="bottom"
                  locale={persian_fa}
                  placeholder="محدوده"
                  fixMainPosition={true}
                  value={dates}
                  onChange={(dateObjects) => {
                    setDates(dateObjects);
                    if (dateObjects.length == 1) {
                      setFilter({
                        ...filter,
                        ["stm"]: dateObjects[0].unix,
                      });
                    }
                    if (dateObjects.length == 2) {
                      setFilter({
                        ...filter,
                        ["ftm"]: dateObjects[1].unix,
                      });
                    }
                    if (dateObjects.length == 0) {
                      setFilter({
                        ...filter,
                        ["ftm"]: "",
                        ["stm"]: "",
                      });
                    }
                  }}
                  plugins={[<DatePanel />]}
                  style={{
                    boxSizing: "border-box",
                    height: "50px",
                    width: "100%",
                    padding: "20px 50px 20px 20px",
                    borderRadius: "15px",
                  }}
                />
                <div className=" position-absolute p-2 icon">
                  <svg
                    fill="#000000"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="30px"
                    height="30px"
                  >
                    <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-6 col-12">
              <div className="position-relative m-2">
                <input
                  type="number"
                  value={filter.public_capacity}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      ["public_capacity"]: e.target.value,
                    })
                  }
                  placeholder="ظرفیت"
                  className="font-regular search w-100 text-start"
                  dir="rtl"
                  style={{ direction: "rtl" }}
                />
                <div className=" position-absolute p-2 icon">
                  <svg
                    fill="#000000"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="30px"
                    height="30px"
                  >
                    <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-6 col-12">
              <div className="position-relative m-1 ">
                <select
                  className="form-select  mb-3 search "
                  value={filter.main_tag_id}
                  onChange={(e) =>
                    setFilter({ ...filter, ["main_tag_id"]: e.target.value })
                  }
                  style={{ fontSize: "14px !important" }}
                  aria-label=" example"
                >
                  <option value="" hidden selected disabled>
                    نوع تور
                  </option>
                  {Tags == undefined
                    ? null
                    : Tags.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                </select>
              </div>
              <div className="d-flex flex-row w-100">
                <button
                  type="button"
                  onClick={() => Filter(filter)}
                  className="btn btn-outline-success mx-3"
                >
                  <FaFilter />
                </button>
                <button
                  type="button"
                  onClick={DeleteFilter}
                  className="btn btn-outline-danger"
                >
                  <FaTrashAlt />
                </button>
              </div>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-primary d-none btn-display mx-3 mb-3 ms-0"
            data-bs-toggle="modal"
            data-bs-target="#filterModal"
          >
            فیتر <FaFilter />
          </button>
          <button
            type="button"
            className="btn btn-danger d-none btn-display mb-3"
            onClick={() => {
              DeleteFilter();
              DeleteFilterInHead();
            }}
          >
            حذف فیلتر <FaTrashAlt />
          </button>
          <div className=" col-lg-9 col-12 ps-5 padding-sm">
            <nav className="tours-tab">
              <div
                className="nav nav-tabs tabs tour-tab"
                id="nav-tab"
                role="tablist"
              >
                <button
                  className="nav-link tour-tab active"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="true"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={25}
                    height={25}
                    fill="currentColor"
                    className="bi bi-images tour-tab"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                    <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z" />
                  </svg>
                </button>
                <button
                  className="nav-link "
                  id="nav-homs-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={25}
                    height={25}
                    fill="currentColor"
                    className="bi bi-list tour-tab"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                    />
                  </svg>
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade "
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-homs-tab"
              >
                <div className="col-12 mt-3 p-2 onelook">
                  <h6
                    className="text-light ms-4 mt-1  font-regular"
                    style={{ color: "rgb(80, 79, 78)" }}
                  >
                    تورهای فعال جمعه صب
                  </h6>
                </div>
                {/*table*/}
                <div className="table-responsive d-flex d-md-block d-none justify-content-center">
                  <table className="table table-borderless">
                    <thead>
                      <tr className="text-center">
                        <th scope="col p-5">
                          <div className="Thead ms-1 p-2">عنوان</div>
                        </th>
                        <th scope="col" className="ms-1">
                          <div className="ms-1 Thead p-2">تاریخ رفت</div>
                        </th>
                        <th scope="col" className="ms-1">
                          <div className="ms-1 Thead p-2">تاریخ برگشت</div>
                        </th>
                        <th scope="col" className="ms-1">
                          <div className="ms-1 Thead p-2">ظرفیت</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Info == undefined ? null : Info == 0 ? (
                        <h1 className="mt-5  ms-3">توری یافت نشد</h1>
                      ) : (
                        Info.map((item, index) =>
                          item.main_status == 4 ? (
                            public_capacity != "" &&
                            parseInt(item.public_capacity) -
                              (parseInt(item.frozen_reserved) +
                                parseInt(item.complate_reserved)) <=
                              0 ? null : (
                              <tr key={index} className="text-center">
                                <Link to={`/tak-tour/${item.id}`}>
                                  <th scope="row" style={{ color: "#310694" }}>
                                    {item.title}
                                  </th>
                                </Link>
                                <td className="digits">{date(item.stm)}</td>
                                <td className="digits">{date(item.ftm)}</td>
                                <td className="digits">
                                  {parseInt(item.public_capacity) -
                                    (parseInt(item.frozen_reserved) +
                                      parseInt(item.complate_reserved)) <=
                                  0
                                    ? " تکمیل"
                                    : `${
                                        parseInt(item.public_capacity) -
                                        (parseInt(item.frozen_reserved) +
                                          parseInt(item.complate_reserved))
                                      }نفر `}
                                </td>
                              </tr>
                            )
                          ) : null
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                {/*cards*/}
                <div className="d-flex flex-wrap d-md-none justify-content-center">
                  {Info == undefined ? null : Info == 0 ? (
                    <h1 className="mt-5 ms-3">توری یافت نشد</h1>
                  ) : (
                    Info.map((item, index) =>
                      item.main_status == 4 ? (
                        public_capacity != "" &&
                        parseInt(item.public_capacity) -
                          (parseInt(item.frozen_reserved) +
                            parseInt(item.complate_reserved)) <=
                          0 ? null : (
                          <Card info={item} key={index} />
                        )
                      ) : null
                    )
                  )}
                </div>
              </div>
              {/*gallery*/}
              <div
                className="tab-pane fade show active"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <div className="d-flex flex-row flex-wrap mt-3 justify-content-center justify-content-md-start">
                  {Info == undefined ? null : Info == 0 ? (
                    <h1 className="mt-5 ms-3">توری یافت نشد</h1>
                  ) : (
                    Info.map((item, index) =>
                      item.main_status == 4 ? (
                        public_capacity != "" &&
                        parseInt(item.public_capacity) -
                          (parseInt(item.frozen_reserved) +
                            parseInt(item.complate_reserved)) <=
                          0 ? null : (
                          <GalleryItem info={item} key={index} date={date} />
                        )
                      ) : null
                    )
                  )}
                </div>
              </div>
            </div>

            <ReactPaginate
              forcePage={pagination}
              previousLabel={"قبلی"}
              nextLabel={"بعدی"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(total_count / 12)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={(e) => {
                setPageNum(e.selected + 1);
                setpagination(e.selected);
              }}
              containerClassName="pagination mb-3 mt-5"
              activeLinkClassName="bg-info text-white"
              activeClassName="style-activeClass"
              pageClassName="style-pageClass mx-2"
              pageLinkClassName="page-link style-page-link  "
              nextClassName="border btn mx-1 style-nextClass p-0 pt-1"
              previousClassName="border btn mx-1 style-previousClass  p-0 pt-1"
              nextLinkClassName="style-nextLink px-4 py-2"
              previousLinkClassName="style-previousLink px-4 py-2"
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="filterModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                فیلتر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body filter-tours-container">
              <div className=" col-sm-12 " id="navbarText">
                <div
                  className="mx-auto"
                  style={{ width: "fit-content" }}
                  href="#"
                >
                  <b>مرتب سازی بر اساس</b>
                </div>
                <ul
                  className="navbar-nav  mx-auto sort"
                  style={{ width: "fit-content" }}
                >
                  <li className="nav-item ">
                    <span
                      className="nav-link"
                      href="#"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check "
                        onClick={() => FilterInHead("stm", 1)}
                        name="btnradio"
                        id="btnradio1"
                        autocomplete="off"
                      />
                      <label
                        data-bs-dismiss="modal"
                        class="btn btn-outline-primary w-100"
                        for="btnradio1"
                      >
                        نزدیک ترین زمان
                      </label>
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className="nav-link "
                      href="#"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio2"
                        autocomplete="off"
                        onClick={() => FilterInHead("mainprice", -1)}
                      />
                      <label
                        data-bs-dismiss="modal"
                        class="btn btn-outline-primary w-100"
                        for="btnradio2"
                      >
                        گرانترین
                      </label>
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      href="#"
                      className="nav-link"
                      style={{ color: "green" }}
                    >
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio3"
                        autocomplete="off"
                        onClick={() => FilterInHead("mainprice")}
                      />
                      <label
                        data-bs-dismiss="modal"
                        class="btn btn-outline-primary w-100"
                        for="btnradio3"
                      >
                        ارزانترین
                      </label>
                    </span>
                  </li>
                </ul>
              </div>

              <div className="col-lg-12 col-md-6 col-12">
                <div className="position-relative m-2">
                  <input
                    type="text"
                    value={filter.tour_title}
                    onChange={(e) =>
                      setFilter({ ...filter, ["tour_title"]: e.target.value })
                    }
                    placeholder="نام تور"
                    className="font-regular search w-100"
                  />

                  <div className=" position-absolute p-2 icon">
                    <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 30 30"
                      width="30px"
                      height="30px"
                    >
                      <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-12 ">
                <div className="position-relative m-2 date-picker">
                  <DatePicker
                    calendar={persian}
                    range
                    id=""
                    mainPosition="bottom"
                    locale={persian_fa}
                    placeholder="محدوده"
                    fixMainPosition={true}
                    value={dates}
                    onChange={(dateObjects) => {
                      setDates(dateObjects);
                      if (dateObjects.length == 1) {
                        setFilter({
                          ...filter,
                          ["stm"]: dateObjects[0].unix,
                        });
                      }
                      if (dateObjects.length == 2) {
                        setFilter({
                          ...filter,
                          ["ftm"]: dateObjects[1].unix,
                        });
                      }
                      if (dateObjects.length == 0) {
                        setFilter({
                          ...filter,
                          ["ftm"]: "",
                          ["stm"]: "",
                        });
                      }
                    }}
                    plugins={[<DatePanel />]}
                    style={{
                      boxSizing: "border-box",
                      height: "50px",
                      width: "100%",
                      padding: "20px 50px 20px 20px",
                      borderRadius: "15px",
                    }}
                  />
                  <div className=" position-absolute p-2 icon">
                    <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 30 30"
                      width="30px"
                      height="30px"
                    >
                      <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-12">
                <div className="position-relative m-2">
                  <input
                    type="number"
                    value={filter.public_capacity}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        ["public_capacity"]: e.target.value,
                      })
                    }
                    placeholder="ظرفیت"
                    className="font-regular search w-100 text-start"
                    dir="rtl"
                    style={{ direction: "rtl" }}
                  />
                  <div className=" position-absolute p-2 icon">
                    <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 30 30"
                      width="30px"
                      height="30px"
                    >
                      <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-12">
                <div className="position-relative m-1 ">
                  <select
                    className="form-select  mb-3 search "
                    value={filter.main_tag_id}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        ["main_tag_id"]: e.target.value,
                      })
                    }
                    style={{ fontSize: "14px !important" }}
                    aria-label=" example"
                  >
                    <option value="" hidden selected disabled>
                      نوع تور
                    </option>
                    {Tags == undefined
                      ? null
                      : Tags.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.title}
                          </option>
                        ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                لغو
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => Filter(filter)}
              >
                فیلتر
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
